<div class="formgrid grid overflow-visible">
  <div class="flex flex-column gap-2 w-full">
    <label for="user">User</label>
    <input [formControl]="user" pInputText class="w-6" id="username" />
    <label for="email">Email</label>
    <input [formControl]="email" pInputText class="w-6" id="email" />
  </div>
</div>
<div class="flex justify-content-end gap-2 mt-2">
  <p-button (onClick)="cancel()" [outlined]="true" label="Cancel" />
  <p-button (onClick)="update()" label="Update User" />
</div>
